// Golfer page Partners chart: the hover card for each partner point. The values
// are rendered on the point as data-tip-* attributes; this only copies them into
// the shared card and positions it over the point's average dot. Presentation
// only. Delegated from document, so Turbolinks page changes need no rebinding.
function showPartnerTip(point) {
  const chart = point.closest('[data-partner-chart]');
  const tip = chart && chart.querySelector('[data-partner-tip]');
  if (!tip) return;

  tip.querySelectorAll('[data-tip-field]').forEach((field) => {
    const key = 'tip' + field.dataset.tipField.charAt(0).toUpperCase() + field.dataset.tipField.slice(1);
    field.textContent = point.dataset[key] || '';
  });

  // Anchor above the average dot, kept inside the chart's width.
  const dot = (point.querySelector('circle') || point).getBoundingClientRect();
  const box = chart.getBoundingClientRect();
  tip.classList.remove('hidden');
  const half = tip.offsetWidth / 2;
  const x = Math.min(Math.max(dot.left + dot.width / 2 - box.left, half), box.width - half);
  tip.style.left = `${x}px`;
  tip.style.top = `${dot.top - box.top - 8}px`;
}

function hidePartnerTip(point) {
  const tip = point.closest('[data-partner-chart]')?.querySelector('[data-partner-tip]');
  if (tip) tip.classList.add('hidden');
}

['mouseover', 'focusin'].forEach((type) => {
  document.addEventListener(type, (event) => {
    const point = event.target.closest && event.target.closest('[data-partner-point]');
    if (point) showPartnerTip(point);
  });
});

['mouseout', 'focusout'].forEach((type) => {
  document.addEventListener(type, (event) => {
    const point = event.target.closest && event.target.closest('[data-partner-point]');
    if (!point) return;
    // Moving between the line, dot and label of the same point is not leaving it.
    if (event.relatedTarget && point.contains(event.relatedTarget)) return;
    hidePartnerTip(point);
  });
});
